export const pages = {
  NONE: null,
  HOME: 'home',
  FINANCE: 'finance',
  ORDERS: 'orders',
  PRODUCTS_AND_PROPOSITIONS: 'products-and-propositions',
  CLIENTS_AND_PARTNERS: 'clients-and-partners',
  RESOURCES: 'resource',
  PENALTIES: 'penalties',
};
